<template>
  <div class="card mb-5 mb-xxl-8 ">
    <div class="card-body">
      <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_session_sale_products" style="margin-top: 13px !important; cursor:pointer">
        <thead>
        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>{{ $t('session.products') }}</th>
          <th>{{ $t('session.unit_price') }}</th>
          <th>{{ $t('session.quantity') }}</th>
          <th>{{ $t('session.amount') }} </th>
        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>
import {BASE_URL} from "@/services/api";
import {mapActions} from "vuex";

export default {
  name: "SaleByProduct",
  data(){
    return{
      formEditData: {
        id: null,
        row: null,
        reference : '',
        customer :'',
        sub_total : 0,
        reduction : 0,
        shop_address : '',
        shop_phone : '',
        shop_name  : '',
        operator : '',
        products: []
      },
      currency: '',
    }
  },
  async mounted(){
    this.fetchProductsDatas()

    let response = await this.getCurrency()
    this.currency = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native
  },

  methods: {
    ...mapActions('shop', ['getCurrency']),

    fetchProductsDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_session_sale_products").DataTable({
        destroy : true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL + '/get/session/' + this.$route.params.sessionId + '/sales/by/products/datatables',
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data:  function ( d ) {

          }
        },
        columns: [{ data: "name" },{ data: "price" },{ data: "quantity" },{ data: "total" }],

        columnDefs: [

          {
            targets: -4,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },

          {
            targets: -3,
            order: "desc",
            className: "dt-center clickable",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ this.currency +"</span></span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },

          {
            targets: -1,
            order: "desc",
            className: "dt-center clickable",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ this.currency +"</span></span>";
            },
          },
        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
